import React from "react";
import { Link } from "react-router-dom";

interface CardProps {
    title?: string;
    image?: string;
    link?: string;
    children?: React.ReactNode;
}
export default function Card({ title, image, link, children }: CardProps) {
    return (
        <Link to={link || ""}>
            <div className="w-full overflow-hidden rounded-lg border shadow">
                <img src={image} alt={title} className="h-48 w-full object-cover" />
                {title && (
                    <div className="p-4">
                        <h2 className="text-xl font-semibold">{title}</h2>
                        {children}
                    </div>
                )}
            </div>
        </Link>
    );
}
